import { render } from "./Popup.vue?vue&type=template&id=c53c553a"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"
script.render = render

export default script